import React, { useRef, useState, useEffect } from "react";
import Layout from "../utils/core/Layout";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { signUpAction } from "../../redux/actions/authentication/authenticationAction";
import { connect } from "react-redux";

export const SignUp = (props) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);

  const password = useRef({});
  password.current = watch("password", "");

  const navigate = useNavigate();

  //Handle form submission
  const onSubmit = (data, event) => {
    data.username = data.username.charAt(0).toUpperCase() + data.username.slice(1);
    data.email = data.email.toLowerCase();
    event.preventDefault();
    if (Object.keys(errors).length === 0) {
      props.signUp(data, navigate);
    }
  };

  // useEffect(() => {
  //     if (localStorage.getItem('access_token') && props.is_user === true) {
  //         navigate('/user/dashboard')
  //     }
  // }, [props, navigate]);

  return (
    <div>
      <Layout>
        <div className="login-page">
          <main>
            <section className="login-area">
              <div className="container">
                <div className="row">
                  <div className="col-lg-4 ">
                    <div className="inner-content features-list-block">
                      <h2>
                        Welcome to <br />
                        the energy sector
                        <br />
                        and a new era
                      </h2>
                      <p>
                        {/* goneet is the energy sector home of all energy people –
                        join and develop, secure your energy future.{" "} */}

goneet is the energy sector home of all energy people –
join, develop and secure your energy future.{" "}
                      </p>
                      {/* <ul className="features-list">
                        <li className="text-center">
                          <div className="img-wrap text-center">
                            <img
                              src="/assets/images/icons/profile.svg"
                              alt="neet"
                            />
                          </div>
                          <div className="feature-name">
                            MY <strong>PROFILE</strong>
                          </div>
                        </li>
                        <li className="text-center">
                          <div className="img-wrap text-center">
                            <img
                              src="/assets/images/icons/analytics.svg"
                              alt="neet"
                            />
                          </div>
                          <div className="feature-name">
                            MY <strong>ANALYTICS</strong>
                          </div>
                        </li>
                        <li className="text-center">
                          <div className="img-wrap text-center">
                            <img
                              src="/assets/images/icons/network.svg"
                              alt="neet"
                            />
                          </div>
                          <div className="feature-name">
                            MY <strong>NETWORK</strong>
                          </div>
                        </li>
                        <li className="text-center">
                          <div className="img-wrap text-center">
                            <img
                              src="/assets/images/icons/performance.svg"
                              alt="neet"
                            />
                          </div>
                          <div className="feature-name">
                            MY <strong>PERFORMANCE</strong>
                          </div>
                        </li>
                      </ul> */}
                    </div>
                  </div>
                  <div className="col-lg-4 ">
                    <div className="login-form">
                      <h5>Register</h5>
                      {/* Display error messages for username and email from signUpError */}
                      {props.signUpError && (
                        <p style={{ color: "red", fontSize: "14px" }}>
                          {props.signUpError.username}
                        </p>
                      )}
                      {props.signUpError && (
                        <p style={{ color: "red", fontSize: "14px" }}>
                          {props.signUpError.email}
                        </p>
                      )}

                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="input-group">
                          <input
                            type="text"
                            name="username"
                            className="form-control"
                            id="username"
                            placeholder="User Name"
                            autoComplete="off"
                            {...register("username", {
                              required: "Username is Required",
                              pattern: {
                                value: /^[a-zA-Z0-9 .!?"-]+$/,
                                message: "Username is not Valid",
                              },
                            })}
                            style={{textTransform:'capitalize'}}
                          />{" "}
                        </div>
                        {/* Display error message for username validation */}
                        {errors.username ? (
                          <p style={{ color: "red", fontSize: "14px" }}>
                            {errors.username?.message}
                          </p>
                        ) : (
                          ""
                        )}

                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            id="email"
                            placeholder="Email"
                            name="email"
                            autoComplete="off"
                            {...register("email", {
                              required: "Email is Required",
                              pattern: {
                                value:
                                  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
                                message: "Email is not Valid",
                              },
                            })}
                          />
                        </div>
                        {errors.email ? (
                          <p style={{ color: "red", fontSize: "14px" }}>
                            {errors.email?.message}
                          </p>
                        ) : (
                          ""
                        )}
                        <div className="input-group table-group">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control"
                            id="password"
                            placeholder="Password"
                            name="password"
                            autoComplete="off"
                            {...register("password", {
                              required: "Password is Required",
                              minLength: {
                                value: 8,
                                message:
                                  "Password must have at least 8 characters",
                              },
                              pattern: {
                                value:
                                  /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(.*\W.*)/g,
                                message:
                                  "Please Enter a one lower, one upper, one digit and one special character",
                              },
                              // pattern: { value: /[A-Z]/g, message: "Please Enter a upper character" },
                              // pattern: { value: /[0-9]/g, message: "Please Enter atleast one digit" },
                            })}
                          />
                          <div className="input-group-append">
                            <button
                              onClick={() => setShowPassword(!showPassword)}
                              className="btn btn-outline-secondary"
                              type="button"
                            >
                              Show
                            </button>
                          </div>
                        </div>
                         {/* Display error message for password validation */}
                        {errors.password ? (
                          <p style={{ color: "red", fontSize: "14px" }}>
                            {errors.password?.message}
                          </p>
                        ) : (
                          ""
                        )}

                        <div className="input-group table-group">
                          <input
                            type={showConfirmPwd ? "text" : "password"}
                            className="form-control"
                            id="confirmPassword"
                            placeholder="Confirm Password"
                            name="confirmPassword"
                            {...register("confirmPassword", {
                              required: "Confirm Password is Required",
                              validate: (value) =>
                                value === password.current ||
                                "The passwords do not match",
                            })}
                          />

                          <div className="input-group-append">
                            <button
                              onClick={() => setShowConfirmPwd(!showConfirmPwd)}
                              className="btn btn-outline-secondary"
                              type="button"
                            >
                              Show
                            </button>
                          </div>
                        </div>
                        {/* Display error message for confirm password validation */}
                        {errors.confirmPassword ? (
                          <p style={{ color: "red", fontSize: "14px" }}>
                            {errors.confirmPassword?.message}
                          </p>
                        ) : (
                          ""
                        )}

                        <div className="login-linkedin">
                          <button type="submit" className="btn btn-secondary">
                            Sign Up
                          </button>
                        </div>
                      </form>

                      <h5>Already have an account</h5>
                      <Link to="/signin" className="btn btn-signup">
                      Log in
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 ">
                    <img src="\assets\images\img7.png"  alt="" 
                     style={{height:'auto',width:'100%'}}
                     />
                  </div>
                </div>
              </div>
            </section>

            <section className="img-list mt-5">
              {/* <div className="container-fluid">
                <div className="row">
                  <div className="col">
                    <figure>
                      <img
                        className="img-fluid w-100"
                        src="/assets/images/img2.png"
                        alt="neet"
                      />
                    </figure>
                  </div>
                  <div className="col">
                    <figure>
                      <img
                        className="img-fluid w-100"
                        src="/assets/images/img3.png"
                        alt="neet"
                      />
                    </figure>
                  </div>
                  <div className="col">
                    <figure>
                      <img
                        className="img-fluid w-100"
                        src="/assets/images/img4.png"
                        alt="neet"
                      />
                    </figure>
                  </div>
                  <div className="col">
                    <figure>
                      <img
                        className="img-fluid w-100"
                        src="/assets/images/img5.png"
                        alt="neet"
                      />
                    </figure>
                  </div>
                  <div className="col">
                    <figure>
                      <img
                        className="img-fluid w-100"
                        src="/assets/images/img6.png"
                        alt="neet"
                      />
                    </figure>
                  </div>
                </div>
              </div> */}
            </section>
          </main>
        </div>
      </Layout>
    </div>
  );
};

// mapStateToProps: Function to map state properties to component props
const mapStateToProps = (state) => {
  const signUpError = state.authentication.signUpError;
  const is_user = state.user.is_user;

  return {
    signUpError: signUpError,
    is_user: is_user,
  };
};

// signUp function dispatches signUpAction with provided data and navigate function
const mapDispatchToProps = (dispatch, state) => {
  return {
    signUp: (data, navigate) => dispatch(signUpAction(data, navigate)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
